/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(licenseId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetLicenseIdentifiers: {
        $xmlns: 'http://dobs.pa.gov/nd/license/bpm/1.0',
        LicenseID: licenseId
      }
    },
    blueprint: {
      id: '$..ID',
      entityName: '$..EntityName',
      entityIsFlagged: '$..HasFlag',
      licenseNumber: '$..LicenseNumber',
      licenseType: '$..LicenseType',
      licenseTypeId: '$..LicenseTypeID',
      licenseStatus: '$..LicenseStatus',
      originalIssueDate: '$..OriginalIssueDate'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      response.originalIssueDate = moment(response.originalIssueDate, moment.ISO_8601).format('MM/DD/YYYY');
      response.entityIsFlagged = response.entityIsFlagged === '1';

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
